import { FC } from "react";
import { useTranslation } from "react-i18next";
import "./ChartErrorState.scss";

interface ChartErrorStateProps {
  onRetry?: () => void;
}

const ChartErrorState: FC<ChartErrorStateProps> = ({ onRetry }) => {
  const { t } = useTranslation();
  return (
    <div className="chart-error-state" role="alert">
      <span className="chart-error-state__icon" aria-hidden>
        ⚠
      </span>
      <p className="chart-error-state__message">
        {t("cpi.chartErrorState.message", "Failed to load")}
      </p>
      {onRetry && (
        <button
          type="button"
          className="chart-error-state__retry"
          onClick={onRetry}
        >
          ↻ {t("cpi.chartErrorState.retry", "Retry")}
        </button>
      )}
    </div>
  );
};

export default ChartErrorState;
